<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12" md="4">
          <DateISOPickerMargin
            label="Từ ngày"
            :date.sync="start"
            outlined
            :rules="[$rules.emptyDate, $rules.dateFromNow]"
            dense
          />
        </v-col>
        <v-col cols="12" md="4">
          <DateISOPickerMargin
            label="Đến ngày"
            :date.sync="end"
            outlined
            :rules="[$rules.emptyDate, $rules.dateFromNow]"
            dense
          />
        </v-col>
      </v-row>
      <v-row class="pb-6 mt-1">
        <v-col class="py-0" cols="12" md="4">
          <v-select
            v-model="present"
            :items="diligenceStatus"
            item-text="title"
            item-value="status"
            label="Trạng thái"
            dense
            outlined
            clearable
            hide-details
          />
        </v-col>
        <v-col class="py-0" cols="12" md="8" v-if="present === 'absent'">
          <RadioAbsentFilter @change="change" />
        </v-col>
        <v-col class="py-0" cols="12" md="8" v-if="present === 'present'">
          <RadioPresentFilter @change="change" />
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <GradeClassStudentSelect @changed="gradeClassStudentChange" />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button mb-6" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import RadioAbsentFilter from './RadioAbsentFilter.vue'
import DateISOPickerMargin from '../../../components/basic/picker/DateISOPickerMargin.vue'
import RadioPresentFilter from './RadioPresentFilter.vue'

export default {
  components: { DateISOPickerMargin, GradeClassStudentSelect, RadioAbsentFilter, RadioPresentFilter },
  data() {
    return {
      selectedGrade: {},
      selectedClass: {},
      selectedStudent: {},
      status: '',
      present: '',
      type: '',
      start: moment()
        .startOf('month')
        .toISOString(),
      end: moment().toISOString()
    }
  },
  computed: {
    ...mapState('constant', ['diligenceStatus']),

    isButtonDisabled() {
      return !this.selectedStudent || Object.keys(this.selectedStudent).length === 0
    }
  },
  mounted() {
    this.onFilterChanged()
  },
  methods: {
    ...mapActions('attendance', ['setDate']),
    gradeClassStudentChange(data) {
      this.selectedGrade = data.grade
      this.selectedClass = data.class
      this.selectedStudent = data.student
    },

    onFilterChanged() {
      const startTime = moment(this.start)
      const endTime = moment(this.end)
      const startOfDay = startTime.startOf('day').toISOString()
      const endOfDay = endTime.endOf('day').toISOString()

      this.setDate(startOfDay)

      const params = {
        date_gte: startOfDay,
        date_lte: endOfDay,
        grade: get(this.selectedGrade, 'id', ''),
        class: get(this.selectedClass, 'id', ''),
        student: get(this.selectedStudent, 'id', '')
      }
      if (this.present === 'present') {
        params.present = 'true'
        if (this.status !== 'all') {
          params.status = this.status
        }
      } else if (this.present === 'absent') {
        params.present = 'false'
        if (this.status !== 'all') {
          params.status = this.status
        }
      }
      this.$emit('onFilterChanged', params)
    },
    change(data) {
      this.status = data
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
